import * as S from './styles'

export const InfoText = ({ children }: { children: React.ReactNode }) => {
  return <S.Wrapper>{children}</S.Wrapper>
}
